module.exports = __webpack_public_path__ + "static/media/26UNRWA3.9213a631.jpg";